import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ColumnTypeIconModule } from '@y42/column-type';
import { SearchDropdownModule } from '@y42/core/search-dropdown';
import { StopPropagationModule } from '@y42/core/stop-propagation';
import { DataTestColumnsCellRendererComponent } from './data-test-columns-cell-renderer.component';

@NgModule({
  declarations: [DataTestColumnsCellRendererComponent],
  imports: [
    CommonModule,
    ColumnTypeIconModule,
    MatTooltipModule,
    MatButtonModule,
    StopPropagationModule,
    MatMenuModule,
    SearchDropdownModule,
  ],
})
export class DataTestColumnsCellRendererModule {}
